// Share Nica Bros via the native share sheet (mobile) with a clipboard fallback.
// Always share the custom game domain — never the preview/host URL.
export const GAME_URL = "https://nicabros.com";
// Featured partner share landing (own OG tags: white logo + Spanish coupon copy). The
// version suffix busts WhatsApp/Messenger preview caches when the preview changes.
export const featuredShareUrl = (lvl) => `${GAME_URL}/${lvl.shareKey}.html?v=${lvl.shareVersion || 1}`;
export const ELTIMON_SHARE_URL = `${GAME_URL}/eltimon.html?v=2`;

export async function shareNicaBros({ text, url }) {
  const link = url || GAME_URL;
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: "Nica Bros", text, url: link });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
      // fall through to clipboard
    }
  }
  try {
    await navigator.clipboard.writeText(`${text} ${link}`);
    return "copied";
  } catch (e) {
    return "failed";
  }
}
